module.exports = __webpack_public_path__ + "img/pdf_sample.7f72e1e8.png";